import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

// const generateUUID = () => {
//   const alphanum = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
//   return Array.from({ length: 6 }, () => alphanum[Math.floor(Math.random() * alphanum.length)]).join('');
// };

export function* handleFetchOrders({ payload }) {
  try {
    const res = yield call(API.fetchOrderDetails, payload);
    const { data } = res;
    yield put(actions.fetchOrderDetailsSuccess(data));
  } catch (err) {
    yield put(actions.fetchOrderDetailsFailure(err?.response?.data));
  }
}

export function* handleUploadReport({ payload }) {
  try {
    // upload file
    console.log(payload);

    // const uuid = generateUUID();

    const labReportMetadataType = payload.labReportMetadata.type;
    const labReportRes = yield call(API.getFileUrl, {
      blobName: `${payload.labReport.name.split(".")[0]}_report_${
        payload.orderId
      }.${payload.labReport.name.split(".")[1]}`,
      source: {
        name: process.env.REACT_APP_ENVIRONMENT,
      },
    });

    const labReportSASToken = labReportRes.data?.data?.document;

    const labReportUploadRes = yield call(API.uploadFile, {
      data: payload.labReport,
      url: labReportSASToken,
    });
    if (labReportUploadRes.status > 400) {
      throw new Error("Error uploading file");
    }

    const labReportMetadataRes = yield call(API.getFileUrl, {
      blobName: `${payload.labReportMetadata.name.split(".")[0]}_metadata_${
        payload.orderId
      }.${payload.labReportMetadata.name.split(".")[1]}`,
      source: {
        name: process.env.REACT_APP_ENVIRONMENT,
      },
    });

    const labReportMetadataSASToken = labReportMetadataRes.data?.data?.document;

    const labReportMetadataUploadRes = yield call(API.uploadFile, {
      data: payload.labReportMetadata,
      url: labReportMetadataSASToken,
    });
    if (labReportMetadataUploadRes.status > 400) {
      throw new Error("Error uploading file");
    }

    const labReportFileName = `${payload.labReport.name.split(".")[0]}_report_${
      payload.orderId
    }.${payload.labReport.name.split(".")[1]}`;
    const labReportMetadataFileName = `${
      payload.labReportMetadata.name.split(".")[0]
    }_metadata_${payload.orderId}.${
      payload.labReportMetadata.name.split(".")[1]
    }`;

    console.log("Lab Report File Name: ", labReportFileName);
    console.log("Lab Report Metadata File Name: ", labReportMetadataFileName);

    yield call(API.saveLabResponseDetails, {
      id: payload.id,
      data: {
        ...payload,
        labReport: labReportFileName,
        labReportMetadata: labReportMetadataFileName,
      },
    });

    // start PDF parsing
    yield call(API.startPdfParsing, {
      order_id: payload.orderId,
    });

    if (payload.onSuccess) {
      payload.onSuccess();
    }
  } catch (err) {
    yield put(actions.uploadReportFailure(err?.response?.data));
    payload.onFailure();
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* labReportUploadSaga() {
  yield takeLatest(actions.fetchOrderDetails.type, handleFetchOrders);
  yield takeEvery(actions.uploadReport.type, handleUploadReport);
}
